// Registers the offline service worker in production builds. A new build
// takes over on the next load; we do not interrupt the reader mid-page.
export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).then((reg) => {
      reg.onupdatefound = () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.onstatechange = () => {
          if (sw.state === 'installed' && navigator.serviceWorker.controller) {
            // New version waiting; activate it so the next navigation gets it.
            sw.postMessage({ type: 'SKIP_WAITING' });
          }
        };
      };
    }).catch((e) => console.error('service worker registration failed', e));
  });
}
